// extracted by mini-css-extract-plugin
export default {"button":"CarouselNavButton_button__pHYcI","left":"CarouselNavButton_left__sw6IE","right":"CarouselNavButton_right__VaLqC","template":"CarouselNavButton_template__bpYIR"};